"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  cancel: {
    "id": "oauth.cancel",
    "defaultMessage": "Cancel"
  },
  paramIsRequired: {
    "id": "oauth.attributeIsRequired",
    "defaultMessage": "{param} is required."
  },
  paramsAreRequired: {
    "id": "oauth.paramsAreRequired",
    "defaultMessage": "{params} are required."
  },
  error: {
    "id": "oauth.error",
    "defaultMessage": "Error"
  },
  success: {
    "id": "oauth.success",
    "defaultMessage": "Success"
  },
  noResults: {
    "id": "oauth.noResults",
    "defaultMessage": "No results"
  },
  loading: {
    "id": "oauth.loading",
    "defaultMessage": "Loading"
  },
  create: {
    "id": "oauth.create",
    "defaultMessage": "Create"
  },
  confirm: {
    "id": "oauth.confirm",
    "defaultMessage": "Confirm"
  },
  nextStep: {
    "id": "oauth.nextStep",
    "defaultMessage": "Next step"
  },
  back: {
    "id": "oauth.back",
    "defaultMessage": "Back"
  },
  save: {
    "id": "oauth.save",
    "defaultMessage": "Save"
  },
  clear: {
    "id": "oauth.clear",
    "defaultMessage": "Clear"
  },
  revert: {
    "id": "oauth.revert",
    "defaultMessage": "Revert"
  },
  edit: {
    "id": "oauth.edit",
    "defaultMessage": "Edit"
  },
  delete: {
    "id": "oauth.delete",
    "defaultMessage": "Delete"
  },
  details: {
    "id": "oauth.details",
    "defaultMessage": "Details"
  },
  yes: {
    "id": "oauth.yes",
    "defaultMessage": "Yes"
  },
  no: {
    "id": "oauth.no",
    "defaultMessage": "No"
  },
  enabled: {
    "id": "oauth.enabled",
    "defaultMessage": "Enabled"
  },
  disabled: {
    "id": "oauth.disabled",
    "defaultMessage": "Disabled"
  },
  close: {
    "id": "oauth.close",
    "defaultMessage": "Close"
  },
  paramToMatchPattern: {
    "id": "oauth.paramToMatchPattern",
    "defaultMessage": "Only characters \"{chars}\" are allowed for {param}."
  },
  mustBeAValidUrl: {
    "id": "oauth.mustBeAValidUrl",
    "defaultMessage": "Parameter \"{param}\" must be a valid URL and cannot end with slash ( / )."
  }
});
exports.messages = messages;
//# sourceMappingURL=messages-i18n.js.map